import { UserRole, BusinessType, AccessRight } from '@wephone-core/system';
import { IUserEntity } from '@wephone-core/model/entity/user.i';

export interface IAuthSuccessInfo {
  username: string;
  domain: string;
  returnUrl: string;
}

export interface LoginPreAuthSessionResp {
  logged_in: boolean;
  onboarding_done: number;
}

export enum LoginErrorCause {
  ACCOUNT_LOCKED = 'account_locked',
  ACCOUNT_NOT_FOUND = 'account_not_found',
  INVALID_PASSWORD = 'invalid_password',
}

export interface IAuthenticationService {
  hasLoggedOut(): boolean;

  has_tried_reconnect();

  getAuthToken();

  getXSRFToken();

  isAuthenticated(): boolean;

  getEnterpriseDomain(): string;

  setEnterpriseDomain(domain: string);

  getUserDisplayName();

  getUserEmail();

  getUserId();

  getAgentId();

  getUserRole(): UserRole;

  isRole(roles: string);

  getBusinessType(): BusinessType;

  getObjectCacheUrl();

  isAdmin();

  isGrantedAccess(access_name: string);

  isSupervisor();

  isAgent();

  isUser();

  isWatcher();

  // getUserRoleAsync();

  getUser(): IUserEntity;

  getUserAsync(): Promise<IUserEntity>;

  getAvatarUrl();

  getUserType();

  loginCookie(returnUrl: string): Promise<boolean>;

  loginToken(): Promise<boolean>;

  reloadSession();

  // checkDomainName(domainName);

  getSavedUsername(domain: string);

  getLastDomain(): Promise<string>;

  setLastDomain(domain: string);

  register(credentials);

  login(user_name: string, password: string, mfaCode: string, domain: string, returnUrl: string);

  logout();

  setLoggedEnterprises(domain: string);

  hasAccessRight(access_name: AccessRight);

}
